module.exports = __webpack_public_path__ + "media/images/Signature_Icon-64337386.svg";